// Empty fs shim for browser compatibility
// Some libraries check for fs but don't actually need it in browser
export const readFileSync = () => '';
export const writeFileSync = () => {};
export const existsSync = () => false;
export const mkdirSync = () => {};
export const readdirSync = () => [];
export const statSync = () => ({});
export const unlinkSync = () => {};
export const rmdirSync = () => {};
export const copyFileSync = () => {};
export const renameSync = () => {};
export const accessSync = () => {};
export const constants = {};

export default {
    readFileSync,
    writeFileSync,
    existsSync,
    mkdirSync,
    readdirSync,
    statSync,
    unlinkSync,
    rmdirSync,
    copyFileSync,
    renameSync,
    accessSync,
    constants,
};
